// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".catalog.products.description[data-v-8f355686],.farmacie-container .container[data-v-8f355686]{padding:0}.farmacie-container.list .product__items[data-v-8f355686]{grid-template-columns:repeat(1,minmax(100px,1fr))}.farmacie-container .product__items[data-v-8f355686]{grid-template-columns:repeat(3,minmax(100px,1fr))}@media(max-width:1200px){.farmacie-container .product__items[data-v-8f355686]{grid-template-columns:repeat(2,minmax(100px,1fr))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
